// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Auth-form-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 80vh;

  }
  
  .Auth-form {
    width: 420px;
    box-shadow: rgb(0 0 0 / 16%) 1px 1px 10px;
    padding-top: 30px;
    padding-bottom: 20px;
    border-radius: 8px;
    background-color: white;
  }
  
  .Auth-form-content {
    padding-left: 12%;
    padding-right: 12%;
  }
  
  .Auth-form-title {
    text-align: center;
    margin-bottom: 1em;
    font-size: 24px;
    color: rgb(34, 34, 34);
    font-weight: 800;
  }
  
  label {
    font-size: 14px;
    font-weight: 600;
    color: rgb(34, 34, 34);
  }
  .password-input {
  position: relative;
}

.password-toggle-icon {
  position: absolute;
  right: 10px; /* Adjust the right position as needed */
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;;EAEd;;EAEA;IACE,YAAY;IACZ,yCAAyC;IACzC,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;EACA;EACA,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,wCAAwC;EACrD,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB","sourcesContent":[".Auth-form-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100vw;\r\n    height: 80vh;\r\n\r\n  }\r\n  \r\n  .Auth-form {\r\n    width: 420px;\r\n    box-shadow: rgb(0 0 0 / 16%) 1px 1px 10px;\r\n    padding-top: 30px;\r\n    padding-bottom: 20px;\r\n    border-radius: 8px;\r\n    background-color: white;\r\n  }\r\n  \r\n  .Auth-form-content {\r\n    padding-left: 12%;\r\n    padding-right: 12%;\r\n  }\r\n  \r\n  .Auth-form-title {\r\n    text-align: center;\r\n    margin-bottom: 1em;\r\n    font-size: 24px;\r\n    color: rgb(34, 34, 34);\r\n    font-weight: 800;\r\n  }\r\n  \r\n  label {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: rgb(34, 34, 34);\r\n  }\r\n  .password-input {\r\n  position: relative;\r\n}\r\n\r\n.password-toggle-icon {\r\n  position: absolute;\r\n  right: 10px; /* Adjust the right position as needed */\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
